export class AppVms {
  _id: string;
  latestBackendVersion: number = 0;

  iosPrefs : PlatformPrefs = new PlatformPrefs();

  androidPrefs : PlatformPrefs = new PlatformPrefs();

  qrScannerPrefs : PlatformPrefs = new PlatformPrefs();

  maintenanceMessage: string = null;

  minimumFrontendVersion: number = 0;

  iosAuth: AuthProviders;

  androidAuth: AuthProviders;

  webAuthProviders: AuthProviders;

  allowUserProfileVerification : boolean;
  buildMode: string;
  buildLogs: BuildLog[] = [];
  restartLog: RestartLog [] = [];

}

export class PlatformPrefs{
  latestVersion : string;
  minimumVersion : string;
  lockPlatform : string;
  constructor() {
  }
}

class BuildLog {
  createTime;
  buildNumber;
}
class RestartLog {
  createTime;
  buildNumber;
}


export class AuthProviders {
  google: boolean;
  apple: boolean;
  whatsapp: boolean;
  phone: boolean;
  email: boolean;

  constructor() {
  }
}
